import React, { useRef, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Taxonomy } from '@uncinc/react-drupal-core';
import Pager from '../../../components/Pager';

import './style.scss';

const ViewRecentTaxonomyOverview = (props) => {
  const { t } = useTranslation();
  const { entities, pager, fullWidth, page, setCurrentPage } = props;

  const ref = useRef(null);
  const viewIsLoaded = useRef(null);

  const totalPages = pager.get('total_pages');
  // Scroll into view
  useEffect(() => {
    if (ref.current) {
      if (viewIsLoaded.current) {
        ref.current.scrollIntoView();
      } else {
        viewIsLoaded.current = true;
      }
    }
  }, [ref, page]);

  const isLoading = useMemo(() => {
    return page !== pager.get('current_page');
  }, [page, pager]);

  return (
    entities.size > 0 ? (
      <div className="ViewRecentTaxonomyOverview">
        <div className="row">
          {entities.map((entity, index) => {
            const id = entity.getIn(['tid', 0, 'value']);
            const uuid = entity.getIn(['uuid', 0, 'value']);
            return (
              <div key={uuid} className={`col-12 ${fullWidth ? '' : 'col-md-6 col-lg-4'}`}>
                <Taxonomy
                  id={id}
                  entity={entity}
                  viewMode="teaser"
                />
              </div>
            );
          })}
        </div>
        {/* Start of Pager */}
        <div className="ViewRecentContentOverview__pager">
          <Pager currentPage={page} totalPages={totalPages} setCurrentPage={setCurrentPage} />
        </div>
        {/* End of Pager */}
      </div>
    ) : (
      <div className="View__no_results">
        <div className="View__no_results__title">
          {isLoading ? (
            <div>
              {t('filters.loading')}
            </div>
          ) : (
            <div>
              {t('filters.no_results')}
            </div>
          )}

        </div>
      </div>
    )
  );
};

export default ViewRecentTaxonomyOverview;
